module.exports = __webpack_public_path__ + "static/otherhero-6fc2b36c4b267a9b170b59436143c1d5.jpg";